import { baseApi } from '../axios';

export const getLecture = async ({ lectureId }: { lectureId?: string }) => {
	const response = await baseApi.get(`/lecture/${lectureId}`);
	return response;
};
